/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { pluralize } from '@utils';

const CarouselItem = ({ module: { content }, errors, previewImg }) => {
  return (
    <InfoItem.WithError
      description={pluralize(content.profiles?.length, 'section')}
      image={previewImg}
      error={errors}
      size="large"
    >
      Profiles module
    </InfoItem.WithError>
  );
};

export default CarouselItem;
